import { useQuery } from '@tanstack/react-query';

import { getExperienceUrgencyTags } from '~/services/ExperiencesService';

import { experiencesQueryKeys } from './experiencesQueryKeys';

export function useGetExperienceUrgencyTags() {
  return useQuery({
    queryKey: experiencesQueryKeys.urgencyTagsList(),
    queryFn: getExperienceUrgencyTags,
  });
}
